import React, { FC } from 'react';
import { Alert, Col, Row, Spin } from 'antd';
import { RouteComponentProps } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CSSProperties } from 'styled-components';

import { ChangeLanguage, PrivacyPolicyFooter } from '~/components';
import SetPassword from './components/SetPassword';
import SmsOtp from './components/SmsOtp';

import './styles.less';
import { useInvitationPageState, useCheckCurrentSession } from '~/hooks/invitation';
import { authCase } from '~/hooks/invitation/invitationPageState';
import NeedLoginCase from './components/NeedLoginCase';
import TerminateSessionCase from './components/TerminateSessionCase';
import AcceptInvitation from './components/AcceptInvitation';
import { brandingName } from '~/branding';
import ConfirmPassword from './components/ConfirmPassword';
import { LogoWithTextImg } from '~/img';

const Invitation: FC<RouteComponentProps> = (props) => {
  const { t } = useTranslation('invitation');

  const [pageState] = useInvitationPageState();
  const sessionCheck = useCheckCurrentSession(pageState?.data?.emailAddress);

  if (!pageState) return null;

  return (
    <>
      <ChangeLanguage />
      <div className="Invitation">
        <Row justify="center" align="middle" className="Invitation-LogoRow">
          <Col>
            <LogoWithTextImg />
          </Col>
        </Row>
        <Row justify="center" align="top" className="Invitation-Row">
          <Col flex="0 1 400px">
            {pageState.isLoading ? (
              <Loading />
            ) : pageState.isError ? (
              <Alert
                type="error"
                message={t('Invitation has expired, has been already used or has been revoked.')}
              />
            ) : sessionCheck.isLoading || sessionCheck.authCase === authCase.WAITING ? (
              <Loading />
            ) : sessionCheck.authCase === authCase.NEED_TERMINATE_CURRENT_SESSION ? (
              <TerminateSessionCase {...props} />
            ) : pageState.showPages.smsOtp ? (
              <SmsOtp />
            ) : pageState.showPages.setPassword ? (
              <SetPassword />
            ) : sessionCheck.authCase === authCase.NEED_TERMINATE_CURRENT_SESSION_AND_LOGIN ? (
              <TerminateSessionCase andLogin {...props} />
            ) : sessionCheck.authCase === authCase.NEED_LOGIN ? (
              <NeedLoginCase {...props} />
            ) : sessionCheck.authCase === authCase.CONFIRM_PASSWORD ? (
              <ConfirmPassword {...props} />
            ) : sessionCheck.authCase === authCase.CURRENT_SESSION_VALID ? (
              <AcceptInvitation {...props} />
            ) : (
              <div>Something went wrong. Contact {brandingName} support.</div>
            )}
          </Col>
        </Row>
      </div>
      <Row gutter={[0, 16]} justify="center" align="middle">
        <Col>
          <PrivacyPolicyFooter />
        </Col>
      </Row>
    </>
  );
};

const Loading: FC = () => {
  return (
    <div style={flexCenter}>
      <Spin size="large" />
    </div>
  );
};

const flexCenter: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flex: 1,
};

export default Invitation;
